import React from 'react';

// The coefficient grid wears the header of its card on the company page
// (CoefficientsCard): small grey capitals on #fcfcfc.
const COEFF_HEADER = 'py-2.5 text-xs font-medium text-gray-500 bg-[#fcfcfc]';
// The line under the head, drawn inside each cell: a table's collapsed border
// stays with the table when the sticky head scrolls, a shadow moves with it.
const HEADER_LINE = 'shadow-[inset_0_-1px_0_#f3f4f6]';

const Thead = ({champsHeader, pathname, type}) => {
    const isCoeff = type === 'coeff';
    const isCompanyPage = !isCoeff && pathname && pathname.includes('company');
    const isQualificationPage = pathname && pathname.includes('qualification');
    const isNocompletedPage = pathname && pathname.includes('nocompleted');
    const headerPyClass = isCompanyPage ? 'py-2.5' : 'py-3.5';
    
    // Définir les largeurs minimales pour les colonnes de relevés d'heures et viviers
    const getMinWidthClass = (index, headerText, pathname) => {
        // Si c'est une table de relevés d'heures (timeSheet ou hours)
        if (pathname && (pathname.includes('timeSheet') || pathname.includes('hours'))) {
            const minWidths = {
                0: 'min-w-[140px]', // N° DE RELEVÉ
                1: 'min-w-[250px]', // ENTREPRISE / RAISON SOCIALE
                2: 'min-w-[250px]', // MISSION / POSTE
                3: 'min-w-[160px]', // N° DE MISSION
                4: 'min-w-[220px]', // INTÉRIMAIRE
                5: 'min-w-[200px]', // ÉTAT / PÉRIODE
                6: 'min-w-[200px]', // PÉRIODE (si présent)
            };
            return minWidths[index] || '';
        }
        return '';
    };

    // Définir les largeurs pour les colonnes
    const getWidthClass = (index, headerText, pathname) => {
        // Si c'est la page company
        if (isCompanyPage) {
            if (index === 0) {
                return 'min-w-[200px]'; // ENSEIGNE
            }
            if (index === 1) {
                return 'min-w-[150px]'; // GROUPE
            }
            if (index === 2) {
                return 'min-w-[150px]'; // REJOINT LE
            }
        }
        // Si c'est la page qualification
        if (isQualificationPage) {
            if (index === 0) {
                return 'min-w-[200px]'; // NOM DU POSTE
            }
            if (index === 1) {
                return 'min-w-[150px]'; // SECTEUR
            }
            if (index === 2) {
                return 'min-w-[120px]'; // TÂCHES
            }
            if (index === 3) {
                return 'min-w-[150px]'; // CRÉÉ LE
            }
        }
        return '';
    };

    return (
        <>
            <tr className="sticky top-0 z-30">
                {
                    champsHeader?.map((item, key) => {
                        // A header may span several columns: { label, colSpan }.
                        const spans = item && typeof item === 'object' && 'label' in item;
                        const label = spans ? item.label : item;
                        return (
                        <th 
                            key={key} 
                            colSpan={spans ? item.colSpan : undefined}
                                className={`sticky top-0 z-30 ${isCoeff ? COEFF_HEADER : `${headerPyClass} text-sm font-medium text-gray-700 bg-gray-50`} text-left ${HEADER_LINE} whitespace-nowrap ${key === 0 ? 'pl-4 pr-2' : 'px-2'} ${getMinWidthClass(key, item, pathname)} ${getWidthClass(key, item, pathname)} transition-colors`}
                        >
                            {typeof label === 'string' ? label.toUpperCase() : label}
                        </th>
                        );
                    })
                }
                {!isNocompletedPage && (
                    <th className={`sticky top-0 z-30 ${isCoeff ? `${COEFF_HEADER} ${HEADER_LINE}` : `${headerPyClass} text-sm font-medium text-gray-700 bg-gray-50 ${HEADER_LINE}`} pl-2 pr-3 text-left w-fit`}></th>
                )}
            </tr>
        </>
    );
};

export default Thead;